import React, { useEffect, useState } from 'react'
import { postinfoAgregarPaquetesQuirurgicos, postTablaInsumosMateralesPaquetes } from '../../../services/PaginaRuta'
import ModalListaDeSuministros from './ModalListaDeSuministros'
import ModalSeleccionPaquetes from './ModalSeleccionPaquetes'
import ModalSeleccionTipoSuministro from './ModalSeleccionTipoSuministro'
import TablaAgregarPaquetesQuirurgicos from './TablaAgregarPaquetesQuirurgicos'

const ModalAgregarPaquetesQuirurgicos = ({setmodalOnAgregarPaquetesQuirurgicos,idCirugia, user, passActualizarTablaProcedimiento}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [modalOnSeleccionTipoSuministro, setmodalOnSeleccionTipoSuministro]= useState(false)
  const [modalOnPaquetes, setmodalOnPaquetes]=useState(false)
  const [modalOnSuministros, setmodalOnSuministros]=useState(false)
  const [dataInPaMa, setdataInPaMa]=useState([])
  const [dataUser, setDataUser]=useState([])
  const [fecha,setFecha]=useState('')
  const [actualizarTablaPaquetes, setactualizarTablaPaquetes]=useState('')

  const passActualizarTablaPaquetes=(data)=>{
    setactualizarTablaPaquetes(data)
    passActualizarTablaProcedimiento(data)
  }

  const handleOnclickPaquetes=()=>{
    setmodalOnPaquetes(true)
  }

  const handleOnclickSuministros=()=>{
    setmodalOnSuministros(true)
  }

  const handleClickSeleccionTipoSuministro=()=>{
    setmodalOnSeleccionTipoSuministro(true)
  }

  const handleCancelClick =() =>{
    setmodalOnAgregarPaquetesQuirurgicos(false)
  }

  useEffect(()=>{

    const body = {
      varProEmpCod: usuarioInfo.Empresa,
      varProMCDpto: usuarioInfo.Sede,
      varProCirCod: idCirugia,
    };
    postTablaInsumosMateralesPaquetes(body).then((res)=>{
      setdataInPaMa(res.data)
      console.log(res.data,'postTablaInsumosMateralesPaquetes ho ')
    })

    const userInfo={
      varProEmpCod:usuarioInfo.Empresa,
      varProMCDpto:usuarioInfo.Sede,
      varProCirCod: idCirugia,
      varMPTDoc: user.MPTDoc,
      varMPCedu: user.MPCedu
    }
    //console.log(,'user.MPTDoc')
    postinfoAgregarPaquetesQuirurgicos(userInfo).then((res)=>{
      //console.log(res.data)
      setDataUser(res.data[0])
      setFecha(res.data[0].ProFec.split(' ')[0])

    })

  },[actualizarTablaPaquetes])

  return (
    <>
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none pt-6">
          <div className=" overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md  bg-[#9e56fe]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Agregar Paquetes Quirúrgicos*
              </h5>
              <button
                type="button"
                onClick={handleCancelClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <form>
              <div className="flex-auto overflow-y-auto relative p-2">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      N° Cirugía
                    </label>
                    <input
                    defaultValue={dataUser.ProCirCod}
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento 
                    </label>
                    <input
                    defaultValue={dataUser.MPCedu}
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tipo Documento
                    </label>
                    <input
                    defaultValue={dataUser.MPTDoc}
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nombre Paciente
                    </label>
                    <input
                    defaultValue={dataUser.MPNOMC}
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <div className="flex-auto overflow-y-auto relative ">
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/4  px-3 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Fecha
                    </label>
                    <input
                      type="date"
                      defaultValue={fecha}
                      disabled={true}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  {/* <div className="w-1/4  px-4 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Paquete
                    </label>
                    <input
                      onClick={handleClickSeleccionTipoSuministro}
                      type="text"
                      autoComplete='off'
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-4 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nombre Paquete
                    </label>
                    <input
                      type="text"
                      autoComplete='off'
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-4 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Cantidad Paquete
                    </label>
                    <input
                      type="text"
                      autoComplete='off'
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div> */}
                  <div className="w-1/4  px-4 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium ">
                      Agregar Paquetes
                    </label>
                    <button
                type="button"
                onClick={handleOnclickPaquetes}
                className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Agregar Paquetes
              </button>
                  </div>
                  <div className="w-1/4  px-4 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium ">
                      Agregar Suministros
                    </label>
                    <button
                type="button"
                onClick={handleOnclickSuministros}
                className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Agregar Suministros
              </button>
                  </div>
                </div>
              </div>
            </form>
            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-2 inline-block min-w-full sm:px-1 ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center">
                        <thead className="border-b bg-gray-200">
                          <tr>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              
                            </th>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Código Paquete
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Descripción Paquete
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cantidad Paquete
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Estado
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            dataInPaMa.map((item,index)=>(
                              <TablaAgregarPaquetesQuirurgicos key={index} item={item} passActualizarTablaPaquetes={passActualizarTablaPaquetes}/>
                            ))
                          }
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button type="button"
              onClick={handleCancelClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal">
              Cerrar
              </button>
              
            </div>
          </div>
        </div>
      </div>
      {modalOnSeleccionTipoSuministro? <ModalSeleccionTipoSuministro setmodalOnSeleccionTipoSuministro={setmodalOnSeleccionTipoSuministro}/>:null}
      {modalOnPaquetes? <ModalSeleccionPaquetes setmodalOnPaquetes={setmodalOnPaquetes} idCirugia={idCirugia} passActualizarTablaPaquetes={passActualizarTablaPaquetes}/>:null}
      {modalOnSuministros? <ModalListaDeSuministros setmodalOnSuministros={setmodalOnSuministros} idCirugia={idCirugia} passActualizarTablaPaquetes={passActualizarTablaPaquetes}/>:null}
    </>
  )
}

export default ModalAgregarPaquetesQuirurgicos